// Scientific pitch → frequency (Hz). A4 = 440 Hz reference; twelve-tone
// equal temperament. Sharps and flats accepted (`C#4`, `Db5`, `Bb3`).
// Enharmonic equivalents resolve to the same freq.

const SEMITONES: Record<string, number> = {
  C: 0,
  'C#': 1,
  Db: 1,
  D: 2,
  'D#': 3,
  Eb: 3,
  E: 4,
  F: 5,
  'F#': 6,
  Gb: 6,
  G: 7,
  'G#': 8,
  Ab: 8,
  A: 9,
  'A#': 10,
  Bb: 10,
  B: 11,
};

const NOTE_RE = /^([A-G])([#b]?)(-?\d+)$/;

export function noteToFreq(note: string): number {
  const match = NOTE_RE.exec(note.trim());
  if (!match) throw new Error(`invalid note: ${note}`);
  const [, letter, accidental, octaveStr] = match;
  const key = `${letter}${accidental}`;
  const semitone = SEMITONES[key];
  if (semitone === undefined) throw new Error(`invalid note: ${note}`);
  const octave = Number(octaveStr);
  // MIDI number: C0 = 12, so pitch = 12 * (octave + 1) + semitone. A4 = 69.
  const midi = 12 * (octave + 1) + semitone;
  return 440 * Math.pow(2, (midi - 69) / 12);
}
